const searchFormModal = document.querySelector('.search-modal .search-form');
const searchFormBlock = document.querySelector('.block-search-form .search-form');
const contentTypesContainer = document.querySelector('.js-sidebar-filters-search');
const searchLandingPageUrl = searchFormBlock?.dataset.searchLandingPage || searchFormModal?.dataset.searchLandingPage || window.location.pathname;

const getSelectedTypes = () => {
    if (!contentTypesContainer) {
        return [];
    }

    return Array.from(contentTypesContainer.querySelectorAll('input[type="checkbox"]:checked'))
        .map((checkbox) => checkbox.value);
};

const getSearchLandingPageUrl = () => {
    if (!searchLandingPageUrl) {
        return window.location.href;
    }

    return searchLandingPageUrl.startsWith('http')
        ? searchLandingPageUrl
        : `${window.origin}${searchLandingPageUrl}`;
};

const search = (e, searchInput, selectedTypes = []) => {
    e.preventDefault();

    const searchTerm = searchInput.value.trim();
    const urlSearchParam = new URLSearchParams();

    if (searchTerm) {
        urlSearchParam.set('searchTerm', searchTerm);
        if (selectedTypes.length > 0) {
            selectedTypes.forEach((type) => {
                urlSearchParam.append('type', type);
            });
        }

        window.location.href = `${getSearchLandingPageUrl()}?${urlSearchParam.toString()}`;
    }
};

document.addEventListener('DOMContentLoaded', () => {
    if (searchFormModal && window.getComputedStyle(searchFormModal).display !== 'none') {
        const searchInput = searchFormModal.querySelector('input');
        const searchButton = searchFormModal.querySelector('.search-form__button');

        searchButton.addEventListener('click', (e) => {
            search(e, searchInput);
        });

        searchInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                search(e, searchInput);
            }
        });
    }

    if (searchFormBlock && window.getComputedStyle(searchFormBlock).display !== 'none') {
        const searchInput = searchFormBlock.querySelector('input');
        const searchButton = searchFormBlock.querySelector('.search-form__button');
        let searchTerm = new URLSearchParams(window.location.search).get('searchTerm');
        let contentTypes = new URLSearchParams(window.location.search).getAll('type');

        if (contentTypes.length > 0) {
            contentTypes.forEach(type => {
                const checkbox = contentTypesContainer?.querySelector(`input[type="checkbox"][value="${type}"]`);

                if (checkbox) {
                    checkbox.checked = true;
                }
            });
        } else {
            const allCheckboxes = contentTypesContainer?.querySelectorAll('input[type="checkbox"]');
            allCheckboxes?.forEach(checkbox => {
                checkbox.checked = true;
            });
        }

        searchInput.value = searchTerm || '';

        searchButton?.addEventListener('click', (e) => {
            search(e, searchInput, getSelectedTypes());
        });

        searchInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                search(e, searchInput, getSelectedTypes());
            }
        });

        if (contentTypesContainer) {
            const allContentTypes = contentTypesContainer.querySelectorAll('input[type="checkbox"]');

            allContentTypes.forEach((checkbox) => {
                checkbox.addEventListener('change', (e) => {
                    if (e.target.type === 'checkbox') {
                        const urlSearchParam = new URLSearchParams();
                        urlSearchParam.set('searchTerm', searchInput.value.trim());

                        const selectedTypes = getSelectedTypes();
                        if (selectedTypes.length > 0) {
                            selectedTypes.forEach((type) => {
                                urlSearchParam.append('type', type);
                            });
                        }

                        window.location.href = `${getSearchLandingPageUrl()}?${urlSearchParam.toString()}`;
                    }
                });
            });
        }
    }
});
